import React, { useState } from "react";
import { Col, Row, Spinner, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import TextField from "common/TextField";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";

import "./index.scss";
import { useTranslation } from "react-i18next";
import { updatePassword } from "services/ChangePassword";
const ChangePassword = ({ setTabs }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const validate = Yup.object({
    newPassword: Yup.string()
      .required("" + t("required"))
      .matches(
        /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[:,?!-._ß@#$%^&*])(?=.{8,})/,
        t("wrong_password_schema")
      ),
    confirmPassword: Yup.string()
      .required("" + t("required"))
      .oneOf([Yup.ref("newPassword"), null], t("password-must-match"))
      .matches(
        /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[:,?!-._ß@#$%^&*])(?=.{8,})/,
        t("wrong_password_schema")
      ),
    oldPassword: Yup.string()
      .required("" + t("required"))
      .matches(
        /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[:,?!-._ß@#$%^&*])(?=.{8,})/,
        t("wrong_password_schema") || ""
      ),
  });
  const initialValues = {
    newPassword: "",
    confirmPassword: "",
    oldPassword: "",
  };

  const handleSubmit = async (values, formikHelpers) => {
    setLoading(true);
    const payLoad = {
      newPassword: values.newPassword,
      oldPassword: values.oldPassword,
    };
    let result = await updatePassword(payLoad);

    if (result?.success) {
      setTabs("changePassword");
      toast.success(t("password_success"));
      setLoading(false);
    }
    if (result?.status === 422) {
      setLoading(false);
      if (result?.data?.message === "Old password not correct") {
        formikHelpers.setFieldError("oldPassword", t("password_old_error"));
      } else {
        formikHelpers.setFieldError("newPassword", t("same_password"));
      }
    }
  };

  return (
    <>
      <div className="password-details">
        <Col md={6}>
          <Formik
            initialValues={initialValues}
            validationSchema={validate}
            onSubmit={(values, actions) => {
              handleSubmit(values, actions);
            }}
          >
            {(formik) => {
              return (
                <>
                  <Form>
                    <p className="info">{t("old-password")}</p>
                    <TextField
                      type="password"
                      placeholder={t("old-password")}
                      name="oldPassword"
                      onChange={formik.handleChange}
                      value={formik.values.oldPassword}
                      error={
                        formik.touched.oldPassword && formik.errors.oldPassword
                      }
                    />
                    <p className="info">{t("new-password")}</p>
                    <TextField
                      type="password"
                      placeholder={t("new-password")}
                      name="newPassword"
                      onChange={formik.handleChange}
                      value={formik.values.newPassword}
                      error={
                        formik.touched.newPassword && formik.errors.newPassword
                      }
                    />
                    <p className="info">{t("confirm-password")}</p>
                    <TextField
                      type="password"
                      placeholder={t("confirm-password")}
                      name="confirmPassword"
                      onChange={formik.handleChange}
                      value={formik.values.confirmPassword}
                      error={
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                      }
                    />
                    <div className="change-password px-3">
                      <p className="m-0 p-0">{t("change-password.step-0")}</p>
                      <ul className="list-unstyled">
                        <li>{t("change-password.step-1")}</li>
                        <li>{t("change-password.step-2")}</li>
                        <li>{t("change-password.step-3")}</li>
                        <li>{t("change-password.step-4")}</li>
                      </ul>
                    </div>
                    <div
                      className="d-flex justify-content-end"
                      style={{
                        padding: "0 0.4rem",
                      }}
                    >
                      <button
                        className={`${!formik.errors.oldPassword &&
                          !formik.errors.newPassword &&
                          !formik.errors.confirmPassword &&
                          !loading
                          ? ""
                          : "opacity-50"
                          } update-btn mb-5 mt-3 w-auto text-white`}
                        disabled={
                          !formik.errors.firstName &&
                            !formik.errors.newPassword &&
                            !formik.errors.confirmPassword &&
                            !loading
                            ? false
                            : true
                        }
                        type="submit"
                      >
                        {loading ? (
                          <div className="d-flex" style={{ gap: "5px" }}>
                            <span>
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            </span>
                            <span>{t("changePassword")}</span>
                          </div>
                        ) : (
                          t("changePassword")
                        )}
                      </button>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </Col>
      </div>
    </>
  );
};

export default ChangePassword;
